import React, { useEffect, useState } from 'react';
import { ReactComponent as DeleteIcon } from '../../../assets/svg/DeleteIcon.svg';
import { deleteKategorijaById, getKategorije, updateListeKategorija } from '../../../server/server-kategorije-tree';
import { notif } from '../../utils/util';
import { DragDropContext } from 'react-beautiful-dnd';
import { Droppable } from 'react-beautiful-dnd';
import { Draggable } from 'react-beautiful-dnd';
import AddKategorijeModal from './AddKategorijeModal';
import { FaEdit } from 'react-icons/fa';

type Inputs = {
    naziv: string;
    opis: string;
    redosled: number | undefined;
};

function KategorijeHome() {
    const [loading, setLoading] = useState(false);
    const [addKategorijaModalOpen, setAddKategorijaModalOpen] = useState(false);
    const [kategorije, setKategorije] = useState<any>([]);
    const [selectedKategorija, setSelectedKategorija] = useState<any>(null);

    useEffect(() => {
        loadKategorije();
    }, []);

    const loadKategorije = async () => {
        const resp = await getKategorije();
        if (resp.status === 200) {
            setKategorije(resp.data);
        }
    };

    const closeAddKategorijaModal = () => {
        setSelectedKategorija(null);
        setAddKategorijaModalOpen(false);
    };
    const openAddKategorijaModal = (item: any) => {
        setSelectedKategorija(item);
        setAddKategorijaModalOpen(true);
    };

    const updateRedosledKategorija = async (lista: any) => {
        setLoading(true);
        const resp = await updateListeKategorija(lista);
        if (resp.status == 201) {
            notif('Uspešno ste promenili raspored kategorija u listi.');
            setKategorije(resp.data);
            setLoading(false);
        } else {
            setLoading(false);
        }
    };

    const removeKategorija = async (id: string) => {
        if (window.confirm('Da li zelis da obrises kategoriju?')) {
            const resp = await deleteKategorijaById(id);
            if (resp.status === 200) {
                notif('Uspesno ste obrisali kategoriju');
                loadKategorije();
            }
        }
    };

    const handleDrop = (droppedItem: any) => {
        // Ignore drop outside droppable container
        if (!droppedItem.destination) return;
        var updatedList = [...kategorije];
        // Remove dragged item
        const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
        // Add dropped item
        updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
        let newReorderList = updatedList.map((item, index) => {
            return { ...item, redosled: index + 1 };
        });
        // Update State
        updateRedosledKategorija(newReorderList);
    };

    return (
        <div className="p-5 h-full">
            <div className="grid grid-cols-2 gap-5 h-full ">
                <div className="h-full overflow-auto ">
                    <div className="flex flex-row items-center justify-between">
                        <label className="text-[16px] leading-5 text-black font-semibold  ">
                            Lista postojecih kategorija <span>(ukupno {kategorije.length})</span>{' '}
                        </label>
                        <button
                            className={`px-3 h-[48px] flex items-center justify-center bg-white border border-black rounded-[4px] text-[16px] leading-5 text-black font-semibold`}
                            onClick={(e) => openAddKategorijaModal(null)}
                        >
                            <p>Dodaj novu kategoriju</p>
                        </button>
                    </div>
                    <DragDropContext onDragEnd={handleDrop}>
                        <Droppable droppableId="list-container">
                            {(provided) => (
                                <div {...provided.droppableProps} ref={provided.innerRef}>
                                    {kategorije
                                        .sort((a: any, b: any) => a.redosled - b.redosled)
                                        .map((item: any, index: number) => {
                                            return (
                                                <Draggable key={index.toString()} draggableId={index.toString()} index={index}>
                                                    {(provided) => (
                                                        <div
                                                            className="bg-white border border-black200 rounded-[4px] px-6 py-[5px] mt-1 flex flex-row items-center justify-between"
                                                            key={index}
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <div>
                                                                <p className="text-[14px] leading-[18px]">
                                                                    Naziv: <span className="font-bold">{item.naziv}</span>
                                                                </p>
                                                                <p className="text-[14px] leading-[18px]">Redosled: {item.redosled}</p>
                                                                <p className="text-[14px] leading-[18px]" style={{ color: item.visible ? 'black' : 'red' }}>
                                                                    Vidljivo: {item.visible ? 'Da' : 'Ne'}
                                                                </p>
                                                            </div>
                                                            <div className=" cursor-pointer p-2 " onClick={() => openAddKategorijaModal(item)}>
                                                                <FaEdit style={{ width: 20, height: 20 }} />
                                                            </div>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            );
                                        })}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>
            </div>
            <AddKategorijeModal
                modalIsOpen={addKategorijaModalOpen}
                closeModal={closeAddKategorijaModal}
                kategorija={selectedKategorija}
                reloadKategorije={loadKategorije}
            />
        </div>
    );
}

export default KategorijeHome;
